import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
// Remove the import that's causing the error
// import logo from '../assets/humanai-logo.png';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;

  const handleUseItFreeClick = () => {
    window.open('https://www.humanaienterprise.com/auth', '_blank');
  };

  const handleDropdownToggle = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleDropdownClose = () => {
    setIsDropdownOpen(false);
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-black/80 backdrop-blur-md">
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center">
            <Link 
              to="/"
              className="text-3xl md:text-4xl font-bold flex items-center"
            >
              <span className="text-white">Human</span>
              <span className="text-pink">AI</span>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <Link 
              to="/"
              className={`transition duration-300 ${currentPath === '/' ? 'text-white' : 'text-gray-300 hover:text-white'}`}
            >
              Home
            </Link>
            <Link 
              to="/blog"
              className={`transition duration-300 ${currentPath === '/blog' ? 'text-white' : 'text-gray-300 hover:text-white'}`}
            >
              Blog
            </Link>
            {/* <Link 
              to="/pricing"
              className={`transition duration-300 ${currentPath === '/pricing' ? 'text-white' : 'text-gray-300 hover:text-white'}`}
            >
              Pricing
            </Link> */}
            <Link 
              to="/learn-more"
              className={`transition duration-300 ${currentPath === '/learn-more' ? 'text-white' : 'text-gray-300 hover:text-white'}`}
            >
              Learn More
            </Link>
            <Link 
              to="/what-is-human-ai"
              className={`transition duration-300 ${currentPath === '/what-is-human-ai' ? 'text-white' : 'text-gray-300 hover:text-white'}`}
            >
              What Is Human AI?
            </Link>
            
            {/* AI Twin Project Dropdown */}
            <div className="relative">
              <button
                onClick={handleDropdownToggle}
                onBlur={() => setTimeout(handleDropdownClose, 150)}
                className="flex items-center text-gray-300 hover:text-white transition duration-300"
              >
                AI Twin Project
                <svg className="ml-1 h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              
              {isDropdownOpen && (
                <div className="absolute top-full left-0 mt-2 w-48 bg-black/90 backdrop-blur-md rounded-lg shadow-lg border border-gray-700">
                  <div className="py-2">
                    <Link 
                      to="/blog/ai-twin-project"
                      className="block px-4 py-2 text-gray-300 hover:text-white hover:bg-gray-800 transition duration-300"
                      onClick={handleDropdownClose}
                    >
                      Learn About
                    </Link>
                    <a 
                      href="https://aitwinproject.com/" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="block px-4 py-2 text-gray-300 hover:text-white hover:bg-gray-800 transition duration-300"
                      onClick={handleDropdownClose}
                    >
                      Visit
                    </a>
                  </div>
                </div>
              )}
            </div>
            
            <button 
              onClick={handleUseItFreeClick}
              className="px-6 py-2 bg-pink hover:bg-pink/90 text-white font-medium rounded-lg transition duration-300"
            >
              Use It Free
            </button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-300 hover:text-white focus:outline-none"
            >
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                {isMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden mt-4 pb-4">
            <div className="flex flex-col space-y-4">
              <Link 
                to="/"
                className={`transition duration-300 ${currentPath === '/' ? 'text-white' : 'text-gray-300 hover:text-white'}`}
                onClick={() => setIsMenuOpen(false)}
              >
                Home
              </Link>
              <Link 
                to="/blog"
                className={`transition duration-300 ${currentPath === '/blog' ? 'text-white' : 'text-gray-300 hover:text-white'}`}
                onClick={() => setIsMenuOpen(false)}
              >
                Blog
              </Link>
              {/* <Link 
                to="/pricing"
                className={`transition duration-300 ${currentPath === '/pricing' ? 'text-white' : 'text-gray-300 hover:text-white'}`}
                onClick={() => setIsMenuOpen(false)}
              >
                Pricing
              </Link> */}
              <Link 
                to="/learn-more"
                className={`transition duration-300 ${currentPath === '/learn-more' ? 'text-white' : 'text-gray-300 hover:text-white'}`}
                onClick={() => setIsMenuOpen(false)}
              >
                Learn More
              </Link>
              <Link 
                to="/what-is-human-ai"
                className={`transition duration-300 ${currentPath === '/what-is-human-ai' ? 'text-white' : 'text-gray-300 hover:text-white'}`}
                onClick={() => setIsMenuOpen(false)}
              >
                What Is Human AI?
              </Link>
              
              {/* AI Twin Project Mobile Dropdown */}
              <div className="border-l-2 border-gray-700 pl-4 ml-2">
                <div className="text-gray-400 text-sm font-medium mb-2">AI Twin Project</div>
                <Link 
                  to="/blog/ai-twin-project"
                  className="block text-gray-300 hover:text-white transition duration-300 mb-2"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Learn About
                </Link>
                <a 
                  href="https://aitwinproject.com/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="block text-gray-300 hover:text-white transition duration-300"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Visit
                </a>
              </div>
              
              <button 
                onClick={() => {
                  handleUseItFreeClick();
                  setIsMenuOpen(false);
                }}
                className="px-6 py-2 bg-pink hover:bg-pink/90 text-white font-medium rounded-lg transition duration-300 inline-block text-center"
              >
                Use It Free
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar; 